<template>
  <v-container v-if="isInvalid">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-alert type="error" class="text-center" border="left" prominent>
          <v-row justify="center">
            <v-col cols="12">
              <h1 class="bold headline">
                <span class="superon-primary">Oops!</span>
              </h1>
              <h1 class="bold headline">
                <span class="superon-secoundary">:|</span>
              </h1>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12">
              <p>Não é possível prosseguir com a redefinição de senha</p>
              <p>
                Provavelmente o link de redefinição expirou. Os links devem ser
                usados em até 24 horas depois da solicitação de recuperação de
                senha. Peça uma nova redefinição pelo aplicativo e você receberá
                um e-mail com mais instruções.
              </p>
              <p>
                Se desejar, entre em contato conosco enviando um e-mail para
                <a href="mailto:contato@lifeapps.com.br"
                  >contato@lifeapps.com.br</a
                >.
              </p>
              <p class="bold superon-primary">Obrigado</p>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>
            <v-row class="d-flex justify-center">
              <v-col cols="12" class="text-center">
                <v-img
                  class="mx-auto mb-5"
                  v-if="logoUrl"
                  :src="logoUrl"
                  max-width="100"
                  contain
                ></v-img>
                <h1 class="bold headline">Recuperação de Senha</h1>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pa-4">
            <div v-if="!isSaved">
              <v-row>
                <v-col>
                  <p>{{ description }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <FormField
                    v-model="pass1"
                    label="Nova senha"
                    typeField="password"
                  ></FormField>
                </v-col>
                <v-col cols="12">
                  <FormField
                    v-model="pass2"
                    label="Verificação da senha"
                    typeField="password"
                  ></FormField>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-alert
                    v-if="error"
                    :type="isSuccess ? 'success' : 'error'"
                    dismissible
                  >
                    {{ error }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row justify="center" class="mb-5">
                <FormButton type="primario" @click="save">Confirmar</FormButton>
              </v-row>
            </div>
            <div v-else>
              <h1 class="bold headline text-center">Sucesso!</h1>
              <h1 class="bold headline text-center">:D</h1>
              <p class="text-center">{{ successMsg }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  RECOVERY_TOKEN,
  RECOVERY_MESSAGES,
  RECOVERY_PASSWORD_UPDATE,
  RECOVERY_PASSWORD_VINCULADO_UPDATE
} from "@/store/actions/recuperarSenha";
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";

export default {
  name: "RecuperarSenha",
  components: { FormButton, FormField },
  data() {
    return {
      isInvalid: false,
      isSaved: false,
      logoUrl: "",
      idfornecedor: "",
      pass1: "",
      pass2: "",
      token: "",
      error: "",
      isSuccess: false,
      messages: {
        error:
          "Algum problema ocorreu ao redefinir sua senha. Talvez o seu token esteja vencido. Tente enviar um novo e-mail novamente pelo aplicativo.",
        success: "Sua senha foi redefinida com sucesso.",
        description: `Vamos te ajudar a recuperar o seu acesso. É bem simples:
          Digite a sua "nova" senha duas vezes e confirme.`
      },
      cliente: "",
      recoveryClass: ""
    };
  },
  computed: {
    isUsuarioVinculado() {
      return this.recoveryClass === "USUARIO_VINCULADO";
    },
    description() {
      return this.messages.description || "";
    },
    successMsg() {
      return this.messages.success || "";
    },
    errorMsg() {
      return this.messages.error || "";
    }
  },
  created() {
    this.token = this.$route.params.token;
    this.getData(this.token);
  },
  methods: {
    getData(token) {
      this.$store
        .dispatch(RECOVERY_TOKEN, {
          token: token
        })
        .then(resp => {
          this.idfornecedor = resp.idfornecedor || "";
          this.cliente = resp.nome_cliente || "";
          this.recoveryClass = resp.class || "";
          this.logoUrl = `${resp.urlImg}/fornec-space/logos/${this.idfornecedor}`;
          this.getMessages();
        })
        .catch(() => {
          this.isInvalid = true;
        });
    },
    getMessages() {
      const data = {
        idfornecedor: this.idfornecedor,
        cliente: this.cliente,
        recoveryClass: this.isUsuarioVinculado ? "USUARIO_VINCULADO" : undefined
      };
      this.$store
        .dispatch(RECOVERY_MESSAGES, data)
        .then(resp => {
          this.initMessages(resp);
        })
        .catch(() => {
          this.isInvalid = true;
        });
    },
    initMessages(messages) {
      const mensagens = messages || [];
      const aliases = this.isUsuarioVinculado
        ? {
            description:
              "msg_exibicao_tela_recuperacao_senha_usuario_vinculado",
            success: "msg_sucesso_recuperacao_senha_usuario_vinculado",
            error: "msg_falha_recuperacao_senha_usuario_vinculado"
          }
        : {
            description: "msg_exibicao_tela_recuperacao_senha",
            success: "msg_sucesso_recuperacao_senha",
            error: "msg_falha_recuperacao_senha"
          };

      mensagens.forEach(m => {
        if (m.alias_evento === aliases.description) {
          this.messages.description = m.mensagem;
        } else if (m.alias_evento === aliases.success) {
          this.messages.success = m.mensagem;
        } else if (m.alias_evento === aliases.error) {
          this.messages.error = m.mensagem;
        }
      });
    },
    isPasswordValid(minLength) {
      if (!this.pass1 || this.pass1.length < minLength) {
        this.showWarning(
          "Você deve usar uma senha com uma combinação de, ao menos, 5 letras ou números"
        );
        return false;
      }
      return true;
    },
    arePasswordsMatching() {
      return this.pass1 === this.pass2;
    },
    save() {
      const minPassLength = 5;
      if (!this.isPasswordValid(minPassLength)) {
        return;
      }
      if (!this.arePasswordsMatching()) {
        this.showWarning(
          "A senha e a confirmação devem ser iguais. Você digitou valores diferentes."
        );
        return;
      }
      this.showWarning(false);
      this.sendSetPasswd();
    },
    showWarning(msg, isSuccess = false) {
      this.isSuccess = isSuccess;
      this.error = msg || "";
    },
    sendSetPasswd() {
      const data = {
        token: this.token,
        newpasswd: this.pass1
      };
      const action = this.isUsuarioVinculado
        ? RECOVERY_PASSWORD_VINCULADO_UPDATE
        : RECOVERY_PASSWORD_UPDATE;

      this.$store
        .dispatch(action, data)
        .then(resp => {
          if (resp.status === "OK") {
            this.isSaved = true;
          } else {
            this.showWarning(resp.err || this.errorMsg);
          }
        })
        .catch(() => {
          this.showWarning(this.errorMsg);
        });
    }
  }
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>
